"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignListPropsSchema = exports.DuplicateCampaignPayloadSchema = exports.DuplicateCampaignSchema = exports.PostFeatureExpCampaignSchema = exports.FeatureExpCampaignWithPaginationSchema = exports.FeatureExpCampaignSchema = exports.FeatureExpStatusSchema = exports.FeatureExpCurrentStateSchema = exports.FeatureExpFolderSchema = exports.FeatureExpCampaignStateSchema = exports.FeatureExpCampaignTypeSchema = void 0;
const zod_1 = require("zod");
const environment_1 = require("../environment");
const variationGroup_1 = require("../variationGroup");
const schemas_1 = require("../schemas");
const schemas_2 = require("../../../helpers/schemas");
exports.FeatureExpCampaignTypeSchema = zod_1.z.enum([
    'ab',
    'toggle',
    'deployment',
    'perso',
    'flag',
    'progressive-rollout',
    'abSample',
    'toggleSample',
]);
exports.FeatureExpCampaignStateSchema = zod_1.z.enum(['active', 'draft', 'paused', 'interrupted', 'hold', 'deleted']);
exports.FeatureExpFolderSchema = zod_1.z
    .object({
    id: zod_1.z.string().optional(),
    name: zod_1.z.string().optional(),
})
    .nullable()
    .optional();
exports.FeatureExpCurrentStateSchema = zod_1.z.object({
    created_at: zod_1.z.string().optional(),
    state: exports.FeatureExpCampaignStateSchema,
    formatted_created_at: schemas_2.ApiDateTimeSchema,
});
exports.FeatureExpStatusSchema = zod_1.z.enum([
    'draft',
    'in_qa',
    'ready_to_launch',
    'play',
    'pause',
    'analysis',
    'interrupted',
    'ended',
    'archive',
]);
exports.FeatureExpCampaignSchema = zod_1.z.object({
    source: zod_1.z.literal('server-side').optional(),
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    is_bucketable: zod_1.z.boolean(),
    is_archived: zod_1.z.boolean().optional(),
    custom_id: zod_1.z.string().nullable(),
    folder: exports.FeatureExpFolderSchema,
    source_project: zod_1.z.string().nullable().optional(),
    project: zod_1.z.object({ id: zod_1.z.string(), name: zod_1.z.string(), emoji: zod_1.z.string().nullable() }),
    type: exports.FeatureExpCampaignTypeSchema,
    wizard_type: exports.FeatureExpCampaignTypeSchema,
    account_environment: environment_1.FeatureExpEnvironmentTypeSchema.pick({
        id: true,
        environment: true,
    }),
    variationGroups: zod_1.z.array(variationGroup_1.FeatureExpVariationGroupSchema).optional(),
    created_at: zod_1.z.string().nullable().optional(),
    formatted_created_at: schemas_2.ApiDateTimeSchema,
    updated_at: zod_1.z.string().nullable().optional(),
    formatted_updated_at: schemas_2.ApiDateTimeSchema.nullable(),
    archived_at: zod_1.z.string().nullable().optional(),
    formatted_archived_at: schemas_2.ApiDateTimeSchema.nullable(),
    scheduled_start_date: zod_1.z.string().nullable().optional(),
    scheduled_stop_date: zod_1.z.string().nullable().optional(),
    scheduled_timezone: zod_1.z.string().nullable().optional(),
    is_sequential_testing_alert_triggered: zod_1.z.boolean().optional(),
    sequential_testing_mode: zod_1.z.any().optional(),
    sequential_testing_setup: zod_1.z.any().optional(),
    current_state: exports.FeatureExpCurrentStateSchema,
    status: exports.FeatureExpStatusSchema.optional(),
    last_play: schemas_2.ApiDateTimeSchema.nullable().optional(),
    last_pause: schemas_2.ApiDateTimeSchema.nullable().optional(),
});
exports.FeatureExpCampaignWithPaginationSchema = schemas_1.FeatureExpPaginationSchema.extend({
    items: zod_1.z.array(exports.FeatureExpCampaignSchema),
});
exports.PostFeatureExpCampaignSchema = exports.FeatureExpCampaignSchema.pick({
    name: true,
    description: true,
    custom_id: true,
    project: true,
    type: true,
    account_environment: true,
    is_bucketable: true,
    wizard_type: true,
}).and(zod_1.z.object({
    account_id: zod_1.z.string(),
}));
exports.DuplicateCampaignSchema = zod_1.z.object({
    account_id: zod_1.z.string(),
    payload: zod_1.z.object({
        environment_id: zod_1.z.string(),
        campaign_id: zod_1.z.string(),
        name: zod_1.z.string(),
        description: zod_1.z.string().nullable(),
        destination_account: zod_1.z.string().optional(),
        destination_account_environment: zod_1.z.string(),
        destination_project: zod_1.z.string(),
        type: zod_1.z.string(),
        source_variation: zod_1.z.string().optional(),
    }),
});
exports.DuplicateCampaignPayloadSchema = exports.DuplicateCampaignSchema.omit({ account_id: true });
exports.CampaignListPropsSchema = schemas_1.FeatureExpPaginationQueryParamSchema.and(zod_1.z.object({
    accountId: zod_1.z.string(),
    search: zod_1.z
        .object({
        name: zod_1.z.string().optional(),
        type: zod_1.z.string().optional(),
    })
        .optional(),
    _order: zod_1.z
        .object({
        name: schemas_1.OrderBySchema.optional(),
        created_at: schemas_1.OrderBySchema.optional(),
    })
        .optional(),
}));
//# sourceMappingURL=schemas.js.map